(function() {
'use strict';

angular
    .module('TR')
    .controller('AgentBookingForm', AgentBookingForm);

function AgentBookingForm(currentUser, agentModeService) {
    const abf = this;
    abf.user = currentUser.get();

    if (TRPCONFIG.Domain.isAgentMode) {
        agentModeService.getAgentInformation().then(function(data) {
            if (data && data.OfficeLocations) {
                abf.officeDetails = data.OfficeLocations;
                data.OfficeLocations.forEach(loc => {
                    if (loc.Id === data.CurrentOfficeLocation) {
                        abf.selectedOffice = loc.Name;
                    }
                });
            }
        });
    }
}
})();
